import script from "./informasi.vue?vue&type=script&setup=true&lang=ts"
export * from "./informasi.vue?vue&type=script&setup=true&lang=ts"

import "./informasi.vue?vue&type=style&index=0&id=69b6e05e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69b6e05e"]])

export default __exports__